module.exports = __webpack_public_path__ + "static/media/videoEditor-9.330f13e7.webp";